module.exports = __webpack_public_path__ + "static/media/2 knee ex.a0ddc0f4.png";